var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box"},[_c('div',[_vm._v("Trusted Provider of Market Leading Test Development and Delivery Solutions")]),_c('div',[_vm._v("©"+_vm._s(_vm.CurrentYear)+" Prometric")])])
}
var staticRenderFns = []

export { render, staticRenderFns }